export default __webpack_public_path__ + "static/media/Terminal.3a5a3216.png";